export const languageService = {
    get
};

function get(){
    let header = {
        'Content-Type': 'application/json'
    }
    const requestOptions = {
        method: 'GET',
        headers: {...header},
    };

    return fetch(`${process.env.REACT_APP_API_URL}languages`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        }).catch(function(error) {
            console.log('There has been a problem with your fetch operation: ',
            error.message);
        });;
}

function handleResponse(response) {
    if(!response.ok){
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            // window.location.reload(true);
        }
        var error = (response && response.message) || response.statusText;
        if(error.length === 0){
            error = 'Internal Server Error'
        }
        return Promise.reject(error);
    }

    return response.json();
}